module.exports = __webpack_public_path__ + "static/img/fish.50efdbed.png";